import PaymentMethod from "./PaymentMethod";
import { AdyenCheckout, Klarna } from "@adyen/adyen-web";
import $Form from "../../common/forms";

export default class AdyenKlarnaPaymentMethod extends PaymentMethod {
  constructor(option, form, paymentPage) {
    super(option, form, paymentPage);

    this.sessionId = $("meta[name=AdyenAuthorizeNowSessionId]").attr("content");
    this.sessionData = $("meta[name=AdyenAuthorizeNowSessionData]").attr("content");
    this.clientKey = $("meta[name=AdyenClientKey]").attr("content");
    this.environment = $("meta[name=AdyenEnvironment]").attr("content");
    this.disclaimer = $("#klarna-disclaimer");
    this.spinner = $("#adyen-klarna-spinner");
    this.klarnaButtonOnClickHandler = this.klarnaButtonOnClickHandler.bind(this);
    this.showSpinner = this.showSpinner.bind(this);
    this.hideSpinner = this.hideSpinner.bind(this);
  }

  async bindFormMethods(paymentPage) {
    super.bindFormMethods(paymentPage);

    const checkout = await AdyenCheckout(this.checkoutConfiguration);
    const klarna = new Klarna(checkout, this.klarnaConfiguration).mount("#adyen-klarna-component");

    klarna.submit();

    this.addOnClickListener();
  }

  get klarnaConfiguration() {
    return {
      useKlarnaWidget: true,
      type: "klarna_account",
    };
  }

  get checkoutConfiguration() {
    return {
      session: {
        id: this.sessionId,
        sessionData: this.sessionData,
      },
      environment: this.environment,
      amount: {
        value: 0,
        currency: "GBP",
      },
      locale: "en-US",
      countryCode: "GB",
      clientKey: this.clientKey,
      showPayButton: false,
      onPaymentCompleted: this.onPaymentCompleted.bind(this),
      onPaymentFailed: this.onPaymentFailed.bind(this),
      onError: this.onError.bind(this)
    };
  }

  addOnClickListener() {
    const target = document.getElementById("adyen-klarna-component");

    if (!target) {
      console.warn("Klarna container not found");
      return;
    }

    const observer = new MutationObserver((mutationsList, observerInstance) => {
      const klarnaButton = target.querySelector("button");
      if (klarnaButton) {
        klarnaButton.addEventListener("click", this.klarnaButtonOnClickHandler.bind(this));

        observerInstance.disconnect();
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  klarnaButtonOnClickHandler() {
    this.paymentPage.disable();
    this.showSpinner();
  }

  showSpinner() {
    this.spinner.removeClass("hidden");
  }

  hideSpinner() {
    this.spinner.addClass("hidden");
  }

  showForm() {
    super.showForm();
    this.disclaimer.removeClass("hidden");
  }

  hideForm() {
    super.hideForm();
    this.disclaimer.addClass("hidden");
  }

  onPaymentCompleted(result, component) {
    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({event: 'klarna_payment_completed', data: {result: result.resultCode}})
    })
    this.form.submit();
  }

  onError(error, component) {
    this.paymentPage.enable();
    this.hideSpinner();

    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({event: 'klarna_payment_error', data: {error: error}})
    })
  }

  onPaymentFailed(result, component) {
    this.paymentPage.enable();
    this.hideSpinner();

    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({event: 'klarna_payment_failed', data: {result: result}})
    })
    $Form.showGeneralError(this.form, "klarna", "There was a problem completing this payment with Klarna. Please select another payment method to complete your booking.");
  }

  async isAvailable() {
    return true;
  }
}
